class Event {
  constructor() {
    this.hdmiRepeater = false
    this.mediaState = null
  }
  async _init() {
    return true
  }

  async resolve(event, data = null) {
    let _event = {}
    if (!event.type) {
      event = {
        type: event,
        detail: data
      }
    }
    /* Platform-specific Event */
    if (event.type === "audioEvent") {
      _event.name = "volumeChanged"
      _event.data = await __.device.volume()
    } else if (event.type === "platformEvent") {
      if (event.detail.state === "focused") _event.name = "applicationFocusing"
      else _event.name = "applicationUnfocused"

      if (__._device.isSTB) __._app._middleware(_event.name)
    } else if (event.type === "mediaEvent") {
      let tempName
      switch (event.detail.state) {
        case "playing":
          if (__.media.status === "playing" && this.mediaState !== "mediaBuffering") return false
          tempName = "mediaPlaying"
          break
        case "ended":
          tempName = "mediaEnded"
          break
        case "stopped":
          if (["stopped", "start"].includes(__.media.status)) return false
          tempName = "mediaStopped"
          break
        case "paused":
          tempName = "mediaPaused"
          break
        case "buffering":
          tempName = "mediaBuffering"
          break
        case "encounteredError":
        case "error":
          tempName = "mediaError"
          break
        default:
          return false
      }
      this.mediaState = tempName || null
      _event.name = tempName
    } else if (["playing", "ended", "stopped", "pause", "error"].indexOf(event.type) >= 0) {
      let tempName
      switch (event.type) {
        case "playing":
          if (__.media.status === "playing") return false
          tempName = "mediaPlaying"
          break
        case "ended":
          tempName = "mediaEnded"
          break
        case "pause":
          tempName = "mediaPaused"
          break
        case "stopped":
          if (["stopped", "start"].includes(__.media.status)) return false
          tempName = "mediaStopped"
          break
        default:
          tempName = "mediaError"
          break
      }
      _event.name = tempName
    } else if (event.type === "screenEvent") {
      _event.name = "power"
      _event.data = event.detail.state ? "on" : "standby"
    } else if (event.type === "networkEvent") {
      _event.name = "network"
      _event.data = event.detail.state
    } else if (event.type === "bluetoothEvent") {
      _event.name = "bluetooth"
      _event.data = event.detail
    } else if (event.type === "messageEvent") {
      let socketData = null
      try {
        socketData = window.atob(event.detail.state)
        socketData = JSON.parse(socketData)
      } catch (e) {
        return _$.error(e)
      }
      if (socketData.hasOwnProperty("action")) _$.vue.$emit("action", socketData)
      else if (socketData.hasOwnProperty("weather")) _$.vue.$emit("weather", socketData)
      else if (socketData.hasOwnProperty("chromecast")) _$.vue.$emit("chromecast", socketData)
      else if (socketData.hasOwnProperty("rc")) _$.vue.$emit("rc-command", socketData)
      else if (socketData.hasOwnProperty("fidelio")) _$.vue.$emit("fidelio", socketData)
      return false
    }
    return _event
  }
}

export default Event
